export const ShoppingAdClick = 'ShoppingAdClick'
export const ShoppingAdLoaded = 'ShoppingAdLoaded'
export const ShoppingAdScroll = 'ShoppingAdScroll'

/**
 * getShoppingAdClickLabel | ShoppingAdClickLabelInput
 */
type GetShoppingAdClickLabelInput = {
  id: string
  pos: number
}
export const getShoppingAdClickLabel = ({ id, pos }: GetShoppingAdClickLabelInput) => {
  return `ad_id=${id};pos=${pos}`
}

/**
 * getShoppingAdLoadedLabel | ShoppingAdLoadedLabelInput
 */
type GetShoppingAdLoadedLabelInput = {
  listingsCount: number
}
export const getShoppingAdLoadedLabel = ({ listingsCount }: GetShoppingAdLoadedLabelInput) => {
  return `num_results=${listingsCount};`
}

/**
 * getShoppingAdScrollLabel | ShoppingAdScrollLabel
 */
export const GA_SCROLL_DIRECTION = {
  forward: 'fwd',
  backward: 'bwd',
} as const

type GetShoppingAdScrollLabelInput = {
  scrollDirection: (typeof GA_SCROLL_DIRECTION)[keyof typeof GA_SCROLL_DIRECTION]
}
export const getShoppingAdScrollLabel = ({ scrollDirection }: GetShoppingAdScrollLabelInput) => {
  return `direction=${scrollDirection}`
}
